import { render, staticRenderFns } from "./DisconectView.vue?vue&type=template&id=e4e40834&"
import script from "./DisconectView.vue?vue&type=script&lang=js&"
export * from "./DisconectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports